import React from "react";
import { useApp } from "@/context/AppContext";
import { API } from "@/lib/api";
import { ASSETS } from "@/lib/assets";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { t } = useApp();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/google";
    window.location.href = `${API}/auth/google/start?redirect_uri=${encodeURIComponent(redirectUri)}&next=${encodeURIComponent("/upload")}`;
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6 py-14">
      <div className="glass-strong rounded-3xl p-10 max-w-md w-full text-center rise-in">
        <img src={ASSETS.logo} alt="AstroFriend" className="h-16 w-16 rounded-full mx-auto ring-2 ring-amber-400/50 floaty" />
        <h1 className="font-serif text-3xl font-bold text-amber-50 mt-6">{t.login.title}</h1>
        <p className="mt-3 text-slate-300">{t.login.subtitle}</p>

        <button onClick={handleGoogle} data-testid="google-login-btn" className="btn-gold w-full rounded-full py-3.5 mt-8 flex items-center justify-center gap-3 gold-glow">
          <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.4 35.9 44 30.4 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
          {t.login.google}
        </button>
        <p className="mt-5 text-xs text-slate-500 flex items-center justify-center gap-1.5">
          <Sparkles size={12} className="text-amber-300" /> {t.login.privacy}
        </p>
      </div>
    </div>
  );
}
